import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getLoteLabById, putLoteLab, patchAgregarEquipoLote, patchRemoverEquipoLote, postEquiposEnLaboratorio, anularLoteLab } from '../../../api/common';
import { Container, Row, Col, Card, Badge, Button, Spinner, ListGroup, Modal, Form, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaArrowLeft, FaEdit, FaPlus, FaTrash, FaCheckCircle, FaSave, FaEye, FaImages, FaClipboardList, FaPauseCircle, FaPlayCircle, FaBan, FaTimesCircle, FaCheckSquare, FaRegCheckSquare } from 'react-icons/fa';
import { Observacioneq } from '../../Equipo/Observacioneq';
import { ViewImage } from '../../Ingresos/ViewImage';
import { Editareq } from '../../Equipo/Editareq';
import { Canceleq } from '../../Equipo/Canceleq';
import { ActivarEq, FinalizarEq, NoFinalizarEq } from '../../EqInOt/FinalizarEq';
import { Modales } from '../../Modales';
import { Modalcarga } from '../../Modales/Modalcarga';
import { useAuth } from '../../../hooks/useAuth';
import Swal from 'sweetalert2';

const LoteDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = useAuth();
  
  const [lote, setLote] = useState(null);

  console.log(lote)
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [equiposDisponibles, setEquiposDisponibles] = useState([]);
  const [loadingDisponibles, setLoadingDisponibles] = useState(false);
  const [selectedToAdd, setSelectedToAdd] = useState([]);
  const [saving, setSaving] = useState(false);
  // Estados para modales de acciones
  const [estadomodal, setEstadomodal] = useState(false);
  const [modalcharge, SetModalcharge] = useState(false);
  const [tarea, setTarea] = useState('');
  const [equipoinfo, setEquipoinfo] = useState({});
  const [refrest, setRefrest] = useState(false);

  const fetchLote = async () => {
    setLoading(true);
    try {
      const res = await getLoteLabById(id);
      const payload = res && res.data ? (res.data.data ?? res.data) : res;
      setLote(payload);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Refetch al montar Y cuando cambia `location.key` — cubre el caso de
  // navegar de vuelta desde /registrar tras la finalización: la pestaña puede
  // conservarse montada según route caching. `location.key` cambia con cada
  // push/pop de historia, forzando la recarga con el estado actualizado del lote.
  useEffect(() => {
    if (id) fetchLote();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, location.key]);

  const handleOpenAddModal = async () => {
    setShowAddModal(true);
    setLoadingDisponibles(true);
    try {
      const res = await postEquiposEnLaboratorio();
      const payload = res && res.data ? (res.data.data ?? res.data) : res;
      const disponibles = Array.isArray(payload) ? payload : [];
      // Filtrar:
      //   1) Equipos ya presentes en ESTE lote (por _id).
      //   2) Equipos que ya están en OTRO lote (loteEnCurso setado por el backend).
      const equiposEnLote = (lote.equipos || []).map(e => String(e._id));
      setEquiposDisponibles(
        disponibles.filter((eq) => (
          !equiposEnLote.includes(String(eq._id)) && !eq.loteEnCurso
        ))
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingDisponibles(false);
    }
  };

  const handleAddEquipos = async () => {
    if (selectedToAdd.length === 0) return;
    setSaving(true);
    try {
      for (const equipoId of selectedToAdd) {
        await patchAgregarEquipoLote(id, { equipoId });
      }
      // Recargar lote
      const res = await getLoteLabById(id);
      const payload = res && res.data ? (res.data.data ?? res.data) : res;
      setLote(payload);
      setShowAddModal(false);
      setSelectedToAdd([]);
    } catch (err) {
      console.error(err);
      alert('Error agregando equipos');
    } finally {
      setSaving(false);
    }
  };

  const handleRemoveEquipo = async (equipoId) => {
    if (!window.confirm('¿Eliminar este equipo del lote?')) return;
    setSaving(true);
    try {
      await patchRemoverEquipoLote(id, { equipoId });
      // Recargar lote
      const res = await getLoteLabById(id);
      const payload = res && res.data ? (res.data.data ?? res.data) : res;
      setLote(payload);
    } catch (err) {
      console.error(err);
      alert('Error eliminando equipo');
    } finally {
      setSaving(false);
    }
  };

  // Anular lote: solo posible en estado 'pendiente'. Elimina LoteCalibracion hijos,
  // libera los equipos a la cola de ingresados y borra el LotCalLab. El backend
  // valida el estado igual — este check es UX-only.
  const handleAnularLote = async () => {
    if (lote?.estado !== 'pendiente') return;
    const totalEquipos = (lote.equipos || []).length;
    const result = await Swal.fire({
      title: `¿Anular lote ${lote.numeroLote || lote._consecutivo}?`,
      html: `
        <div class="text-start">
          <p>Esta acción:</p>
          <ul class="text-start mb-0">
            <li>Elimina el lote completo y los <strong>${totalEquipos}</strong> equipos asociados.</li>
            <li>Libera los equipos para incluirlos en un nuevo lote.</li>
            <li>Elimina cualquier configuración de plantilla ya guardada en este lote.</li>
          </ul>
          <p class="mt-3 text-danger"><strong>No se puede deshacer.</strong></p>
        </div>
      `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, anular',
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    });
    if (!result.isConfirmed) return;

    setSaving(true);
    try {
      const res = await anularLoteLab(id);
      const body = res?.data || res;
      await Swal.fire({
        title: 'Lote anulado',
        html: `${body?.data?.equiposLiberados ?? 0} equipo(s) liberado(s). Volverás al listado.`,
        icon: 'success',
        timer: 2500,
        showConfirmButton: false
      });
      // Volver al panel de Gestión de Ingresos con el tab de Lotes activo,
      // no a `/mediciones/lotes` directo (esa ruta renderiza LotesList sin el
      // wrapper de tabs, quedaba visualmente huérfano).
      navigate('/Ingresos/listar', { state: { activeTab: 'lotesCal' } });
    } catch (err) {
      console.error('Error anulando lote:', err);
      const msg = err?.response?.data?.message || err?.message || 'No se pudo anular el lote.';
      await Swal.fire({ title: 'Error', text: msg, icon: 'error' });
    } finally {
      setSaving(false);
    }
  };

  // Handlers para acciones de equipos
  const observacion = (eq) => {
    setEquipoinfo(eq);
    setTarea('Observacion');
    setEstadomodal(true);
  };

  const viewImg = (eq) => {
    setEquipoinfo(eq);
    setTarea('viewImg');
    setEstadomodal(true);
  };

  const AccesoriosView = (eq) => {
    setEquipoinfo(eq);
    setTarea('Accesorios');
    setEstadomodal(true);
  };

  const Activar = async (equipo) => {
    try {
      await ActivarEq(
        equipo._id, 
        equipo.ot?.numeroOrden || equipo.ot, 
        equipo.ot?.visitas || -1, 
        SetModalcharge, 
        userData._id, 
        equipo.ot, 
        equipo
      );
      setRefrest(!refrest);
      fetchLote();
    } catch (error) {
      console.error('Error al activar equipo:', error);
    }
  };

  const NoFinalizar = async (equipo) => {
    try {
      await NoFinalizarEq(equipo._id, SetModalcharge, null);
      setRefrest(!refrest);
      fetchLote();
    } catch (error) {
      console.error('Error al marcar como no finalizado:', error);
    }
  };

  const Finalizar = async (equipo) => {
    try {
      await FinalizarEq(
        equipo._id, 
        equipo.ot, 
        equipo.ot?.visitas || -1, 
        SetModalcharge, 
        userData, 
        null
      );
      setRefrest(!refrest);
      fetchLote();
    } catch (error) {
      console.error('Error al finalizar equipo:', error);
    }
  };

  const Editequipo = (eq) => {
    setEquipoinfo(eq);
    setTarea('Editar');
    setEstadomodal(true);
  };

  const Cancelareq = (eq) => {
    console.log(eq);
    setEquipoinfo(eq);
    setTarea('Cancelar');
    setEstadomodal(true);
  };

  const toggleSelectToAdd = (equipoId) => {
    setSelectedToAdd(prev => prev.includes(equipoId) ? prev.filter(x => x !== equipoId) : [...prev, equipoId]);
  };

  if (loading || !lote) return (
    <Container className="py-5">
      <div className="text-center">
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Cargando lote...</p>
      </div>
    </Container>
  );

  return (
    <Container fluid className="py-4">
      {/* Header profesional */}
      <Card className="shadow-sm mb-4 w-100" style={{borderRadius: '12px', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
        <Card.Body className="text-white py-4 w-100">
          <Row className="align-items-center">
            <Col>
              <Button variant="light" onClick={()=>navigate(-1)} className="me-3" style={{borderRadius: '8px'}}>
                <FaArrowLeft className="me-2" /> Volver
              </Button>
              <h3 className="d-inline mb-0">Lote {lote._consecutivo ?? lote.numeroLote}</h3>
            </Col>
            <Col className="text-end d-flex justify-content-end align-items-center gap-2">
              {/* Anular lote — solo permitido cuando estado === 'pendiente'.
                  Elimina LoteCalibracion hijos y libera equipos a la cola. */}
              {lote.estado === 'pendiente' && (
                <Button
                  variant="danger"
                  size="sm"
                  onClick={handleAnularLote}
                  disabled={saving}
                  style={{borderRadius: '8px'}}
                  title="Anular el lote y liberar los equipos"
                >
                  <FaBan className="me-1" /> Anular lote
                </Button>
              )}
              <Badge
                bg={
                  lote.estado === 'pendiente' ? 'warning'
                  : lote.estado === 'abierto' ? 'success'
                  : lote.estado === 'en_progreso' ? 'info'
                  : lote.estado === 'cerrado' ? 'dark'
                  : 'secondary'
                }
                style={{fontSize: '1rem', padding: '8px 16px', borderRadius: '20px'}}
              >
                {/* Renombrar 'cerrado' → 'Procesado' en UI (usuarios esperan ese label). */}
                {lote.estado === 'cerrado' ? 'Procesado' : lote.estado}
              </Badge>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Row className="g-4">
        {/* Información del lote */}
       {/* <Col md={4}>
          <Card className="shadow-sm h-100 w-100" style={{borderRadius: '12px'}}>
            <Card.Header className="bg-primary text-white w-100" style={{borderRadius: '12px 12px 0 0'}}>
              <h5 className="mb-0">Información del Lote</h5>
            </Card.Header>
            <Card.Body className='w-100'>
              <ListGroup variant="flush">
                <ListGroup.Item className="border-0 px-0">
                  <small className="text-muted d-block">Responsable</small>
                  <strong>{lote.responsable ? `${lote.responsable.nombre} ${lote.responsable.apellido || ''}` : '-'}</strong>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 px-0">
                  <small className="text-muted d-block">Plantilla</small>
                  <strong>{lote.plantillaId?.codigo ?? '-'}</strong>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 px-0">
                  <small className="text-muted d-block">Total equipos</small>
                  <Badge bg="secondary" pill style={{fontSize: '1rem'}}>{(lote.equipos||[]).length}</Badge>
                </ListGroup.Item>
                <ListGroup.Item className="border-0 px-0">
                  <small className="text-muted d-block">Fecha creación</small>
                  <strong>{lote.createdAt ? new Date(lote.createdAt).toLocaleDateString() : '-'}</strong>
                </ListGroup.Item>
              </ListGroup>

              <div className="d-grid gap-2 mt-4">
                <Button variant="outline-primary" style={{borderRadius: '8px'}} disabled>
                  <FaEdit className="me-2" /> Editar información
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>*/}

        {/* Equipos del lote */}
        <Col md={12}>
          <Card className="shadow-sm w-100" style={{borderRadius: '12px'}}>
            <Card.Header className="bg-light w-100" style={{borderRadius: '12px 12px 0 0'}}>
              <Row className="align-items-center">
                <Col>
                  <h5 className="mb-0">Equipos en el Lote ({(lote.equipos||[]).length})</h5>
                </Col>
                <Col className="text-end">
                  <Button
                    variant="primary"
                    size="sm"
                    onClick={() => navigate(`/mediciones/lotes/${id}/registrar`)}
                    className="me-2"
                    style={{borderRadius: '8px'}}
                  >
                    <FaSave className="me-1" /> Registrar Mediciones
                  </Button>
                  {/* Bloquear "Agregar equipos" y "Finalizar de nuevo" cuando el lote
                      ya se cerró tras la finalización. Ver Feat C spec R2 (idempotencia). */}
                  <Button
                    variant="success"
                    size="sm"
                    onClick={handleOpenAddModal}
                    style={{borderRadius: '8px'}}
                    disabled={lote.estado === 'cerrado'}
                    title={lote.estado === 'cerrado' ? 'Lote procesado — no se pueden agregar equipos' : 'Agregar equipos al lote'}
                  >
                    <FaPlus className="me-1" /> Agregar equipos
                  </Button>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0 w-100">
              {(lote.equipos || []).length === 0 ? (
                <div className="text-center py-5">
                  <p className="text-muted">No hay equipos en este lote</p>
                </div>
              ) : (
                <Table responsive hover className="mb-0">
                  <thead style={{backgroundColor: '#f8f9fa'}}>
                    <tr>
                      <th className="py-3" style={{width: '15%'}}>Equipo</th>
                      <th className="py-3" style={{width: '12%'}}>Ubicación</th>
                      <th className="py-3" style={{width: '12%'}}>Cliente</th>
                      <th className="py-3" style={{width: '8%'}}>Ot</th>
                      <th className="py-3" style={{width: '10%'}}>Consecutivo</th>
                      <th className='py-3' style={{width: '8%'}}>Puntos</th>
                      <th className="py-3" style={{width: '10%'}}>Estado</th>
                      <th className="py-3 text-center" style={{width: '7%'}}>Pro</th>
                      <th className="py-3 text-center" style={{width: '18%'}}>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {lote.equipos.map(eq => (
                      <tr key={eq._id}>
                        <td className="align-middle">
                          <div><strong>{eq?.snapshot?.item??  eq?.snapshot?.item}</strong></div>
                          <div className="small text-muted">
                            {eq?.snapshot?.marca ?? eq?.marca ?? '-'} • {eq?.snapshot?.modelo ?? eq?.modelo ?? '-'} • {eq?.snapshot?.serial ?? eq?.serie ?? '-'}
                          </div>
                        </td>
                        <td className="align-middle">
                            <div><strong>{eq?.snapshot?.ubicacion ?? eq?.ubicacion ?? '-'}</strong></div>
                            <div className="small text-muted"> 
                                {eq?.snapshot?.inventario ?? eq?.inventario ?? '-'} 
                            </div>
                        </td>
                        <td className="align-middle">
                            <div><strong>{eq?.equipo?.cliente?.nombre ?? eq?.cliente?.nombre ?? '-'}</strong></div>
                            <div className="small text-muted">{eq?.equipo?.sede ?? eq?.sede ?? '-'}</div>
                        </td>
                        <td className="align-middle">{eq?.equipo?.ot?.numeroOrden ?? eq?.ot ?? '-'}</td>
                        <td className="align-middle"><Badge bg="dark">{eq.consecutivo ?? '-'}</Badge></td>
                        <td className='align-middle'>{eq.equipo.puntos}</td>
                        <td className="align-middle">
                          <Badge
                            bg={
                              eq.estado === 'Finalizado' || eq.estado === 'Procesado' || eq.estado === 'calibrado'
                                ? 'success'
                                : eq.estado === 'En Proceso' || eq.estado === 'en_laboratorio'
                                  ? 'info'
                                  : eq.estado === 'Cancelado'
                                    ? 'danger'
                                    : 'secondary'
                            }
                            style={{borderRadius: '20px', padding: '6px 12px'}}
                          >
                            {/* Alinear con backend: FINISHED='Finalizado'. Los usuarios
                               esperan ver "Procesado" en la UI, así que renombramos. */}
                            {eq.estado === 'Finalizado' ? 'Procesado' : eq.estado}
                          </Badge>
                        </td>
                        <td className="align-middle text-center">
                          {eq?.estado === 'Cancelado' ? (
                            <FaBan className="text-danger" size={18} />
                          ) : (eq?.estado === 'Procesado' || eq?.estado === 'Finalizado' || eq?.estado === 'Aprobado' || eq?.estado === 'Entregado') ? (
                            <FaCheckSquare
                              className="text-success cursor-pointer"
                              size={18}
                              onClick={() => !eq?.equipo?.fechaCalibracion && NoFinalizar(eq)}
                              style={{cursor: !eq?.equipo?.fechaCalibracion ? 'pointer' : 'not-allowed'}}
                            />
                          ) : eq?.estado === 'Pendiente' || eq?.estado === 'Aplazado' ? (
                            <FaPauseCircle 
                              className="text-warning cursor-pointer" 
                              size={18}
                              onClick={() => !eq?.equipo?.fechaCalibracion && Activar(eq)}
                              style={{cursor: !eq?.equipo?.fechaCalibracion ? 'pointer' : 'not-allowed'}}
                            />
                          ) : (
                            <FaRegCheckSquare
                              className={eq?.equipo?.fechaCalibracion ? 'text-success' : 'text-secondary cursor-pointer'} 
                              size={18}
                              onClick={() => !eq?.equipo?.fechaCalibracion && Finalizar(eq)}
                              style={{cursor: !eq?.equipo?.fechaCalibracion ? 'pointer' : 'not-allowed'}}
                            />
                          )}
                        </td>

                        <td className="align-middle text-center">
                          <div className="d-flex gap-1 justify-content-center flex-wrap">
                            {/* Accesorios */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Accesorios</Tooltip>}>
                              <Button 
                                size="sm" 
                                variant="outline-info" 
                                onClick={() => AccesoriosView(eq)}
                                style={{borderRadius: '6px'}}
                              >
                                <FaClipboardList />
                              </Button>
                            </OverlayTrigger>

                            {/* Observación */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Observación</Tooltip>}>
                              <Button 
                                size="sm" 
                                variant="outline-primary" 
                                onClick={() => observacion(eq)}
                                style={{borderRadius: '6px'}}
                              >
                                <FaEye />
                              </Button>
                            </OverlayTrigger>

                            {/* Fotos */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Fotos</Tooltip>}>
                              <Button 
                                size="sm" 
                                variant="outline-secondary" 
                                disabled={!(eq.fotos && eq.fotos.length > 0)}
                                onClick={() => viewImg(eq)}
                                style={{borderRadius: '6px'}}
                              >
                                <FaImages />
                              </Button>
                            </OverlayTrigger>

                            {/* Editar */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Editar</Tooltip>}>
                              <Button 
                                size="sm" 
                                variant="outline-primary" 
                                onClick={() => Editequipo(eq)}
                                style={{borderRadius: '6px'}}
                              >
                                <FaEdit />
                              </Button>
                            </OverlayTrigger>

                            {/* Cancelar */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Cancelar equipo</Tooltip>}>
                              <Button 
                                size="sm" 
                                variant="outline-danger" 
                                disabled={eq.estado === 'Cancelado'}
                                onClick={() => Cancelareq(eq)}
                                style={{borderRadius: '6px'}}
                              >
                                <FaTimesCircle />
                              </Button>
                            </OverlayTrigger>

                            {/* Eliminar del lote */}
                            <OverlayTrigger placement="top" overlay={<Tooltip>Eliminar del lote</Tooltip>}>
                              <Button 
                                size="sm" 
                                variant="outline-danger" 
                                onClick={() => handleRemoveEquipo(eq._id)}
                                disabled={saving}
                                style={{borderRadius: '6px'}}
                              >
                                <FaTrash />
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal agregar equipos */}
      <Modal show={showAddModal} onHide={()=>setShowAddModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Agregar Equipos al Lote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingDisponibles ? (
            <div className="text-center py-4">
              <Spinner animation="border" />
              <p className="mt-2">Cargando equipos disponibles...</p>
            </div>
          ) : equiposDisponibles.length === 0 ? (
            <div className="alert alert-info">No hay equipos disponibles para agregar</div>
          ) : (
            <Table responsive hover>
              <thead>
                <tr>
                  <th style={{width: '40px'}}>
                    <Form.Check type="checkbox" onChange={(e)=>setSelectedToAdd(e.target.checked ? equiposDisponibles.map(eq=>eq._id) : [])} />
                  </th>
                  <th>Equipo</th>
                  <th>Cliente</th>
                  <th>Consecutivo</th>
                </tr>
              </thead>
              <tbody>
                {equiposDisponibles.map(eq => (
                  <tr key={eq._id}>
                    <td>
                      <Form.Check type="checkbox" checked={selectedToAdd.includes(eq._id)} onChange={()=>toggleSelectToAdd(eq._id)} />
                    </td>
                    <td>
                      <div><strong>{eq?.equipo?.item?.nombre ?? '-'}</strong></div>
                      <div className="small text-muted">{eq?.equipo?.marca} • {eq?.equipo?.modelo}</div>
                    </td>
                    <td>{eq?.equipo?.cliente?.nombre ?? '-'}</td>
                    <td><Badge bg="dark">{eq.consecutivo}</Badge></td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={()=>setShowAddModal(false)}>Cancelar</Button>
          <Button variant="primary" onClick={handleAddEquipos} disabled={saving || selectedToAdd.length===0}>
            {saving ? <><Spinner animation="border" size="sm" /> Agregando...</> : <><FaCheckCircle className="me-1" /> Agregar ({selectedToAdd.length})</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modales de acciones */}
      <Modales
        estado={estadomodal}
        cambiarestado={setEstadomodal}
        titulo={tarea === 'Accesorios' ? 'Accesorios del Equipo' : 
                tarea === 'Observacion' ? 'Observación' : 
                tarea === 'viewImg' ? 'Fotos del Equipo' : 
                tarea === 'Editar' ? 'Editar Equipo' : 
                tarea === 'Cancelar' ? 'Cancelar Equipo' : 'Acción'}
      >
        {tarea === 'Accesorios' && (
          <div className="p-3">
            <h5>Accesorios - {equipoinfo?.consecutivo}</h5>
            <p className="text-muted">Lista de accesorios del equipo</p>
            {equipoinfo?.equipo?.accesorios && equipoinfo.equipo.accesorios.length > 0 ? (
              <ListGroup>
                {equipoinfo.equipo.accesorios.map((acc, idx) => (
                  <ListGroup.Item key={idx}>{acc}</ListGroup.Item>
                ))}
              </ListGroup>
            ) : equipoinfo?.accesorios && equipoinfo.accesorios.length > 0 ? (
              <ListGroup>
                {equipoinfo.accesorios.map((acc, idx) => (
                  <ListGroup.Item key={idx}>{acc}</ListGroup.Item>
                ))}
              </ListGroup>
            ) : (
              <p className="text-muted">No hay accesorios registrados</p>
            )}
          </div>



        )}
        {tarea === 'Observacion' && (
          <Observacioneq 
            infoobservacion={equipoinfo?.observacion ? equipoinfo.observacion + " -- " + (equipoinfo?.equipo?.observacion || '') : equipoinfo?.equipo?.observacion || 'Sin observaciones'} 
            cambiarestado={setEstadomodal}
          />
        )}
        {tarea === 'viewImg' && (
          <ViewImage 
            eqinfo={equipoinfo?.equipo || equipoinfo}
          />
        )}
        {tarea === 'Editar' && (
          <Editareq 
            infoequipo={equipoinfo} 
            cambiarestado={setEstadomodal}
            refresh={refrest}
            refrescar={() => {
              setRefrest(!refrest);
              fetchLote();
            }}
          />
        )}
        {tarea === 'Cancelar' && (
          <Canceleq 
            infoOt={{numeroOrden: equipoinfo?.ot, visitas: equipoinfo?.equipo?.visitas || 0}}
            iditem={equipoinfo?._id } 
            cambiarestado={setEstadomodal}
            refresh={refrest}
            setRefresh={() => {
              setRefrest(!refrest);
              fetchLote();
            }}
          />
        )}
      </Modales>

      <Modalcarga show={modalcharge} />
    </Container>
  );
};

export default LoteDetail;
